import notify from 'devextreme/ui/notify';
export const showNotify = ({
    text,
    type = "info" | "warning" | "success" | "error" | "default",
    time = 3000
}) => {
    notify(text, type, time);
}